import { useState } from "react";
import "./LoiDate.scss";
import classNames from "classnames";
import datesArray from "./dates";
export default function LoiDateSettings() {
  const [isSettingsModified, setSettingsModified] = useState(false);

  const toggleCheck = () => {};
  const CustomCheckbox = () => {
    return (
      <div
        className="custom-checkbox"
        onClick={() => {
          toggleCheck();
        }}
      ></div>
    );
  };

  return (
    <div className="date-settings-container">
      <div className="date-content-container">
        <div className="content-header-container">
          <h3 className="header-text">Preferred LOI Date Format</h3>
        </div>
        <div className="content-checkbox-container">
          <div className="checkbox-row-1">
            <div className="checkbox-content">
                <input type="checkbox" className="custom-checkbox" />
                <p className="row-1-check-text">Keep date format from LOI</p>
            </div>
          </div>
          <div className="checkbox-row-2">
            {datesArray?.map((each)=>{
                return <div className="checkbox-content">
                <input type="checkbox" className="custom-checkbox" />
                <p className="row-1-check-text">{each?.date}</p>
            </div>
            })}
          </div>
        </div>
      </div>
      <div className="bottom-container">
        {/* <div className="gs-reset-holder">
          <p>Reset All Settings to Default Values</p>
          <button
            className="settings-button-reset"
            //   onClick={handleResetToDefault}
          >
            Reset All
          </button>
        </div> */}
        <div></div>
        <div className="gs-button-container">
          {isSettingsModified && (
            <button
              disabled={!isSettingsModified}
              className={classNames("settings-button", {
                "button-oranges": isSettingsModified,
              })}
              //   onClick={handleApply}
            >
              Apply
            </button>
          )}
          {!isSettingsModified && (
            <button
              className="settings-button"
              //    onClick={'handleClose'}
            >
              Close
            </button>
          )}
          {isSettingsModified && (
            <button
              className="settings-button"
              //   onClick={handleCancel}
            >
              Cancel
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
